const colors = {
  primary: {
    violetDark: "#332B41",
    white1: "#FFFFFF",
    white2: "#F3F5F8",
    blue1: "#188DE4",
    blue2: "#E2E6FB",
    blue3: "#EFF2FD",
    lightBlue1: "#00C1F6",
    lightBlue2: "#D9F6FE",
    lightBlue3: "#EBFAFF",
    lightBlue4: "#63B7F5",
    strokeBlue: "#96A3EA",
    green: "#3EA293",
    red: "#F23E3E"
  },
  secondary: {
    black: "#000000",
    gray15: "#22242D",
    gray20: "#333333",
    gray30: "#4E4F57",
    gray40: "#747881",
    gray70: "#ACAEB3",
    gray80: "#C7C9CD",
    gray85: "#D5D6D9",
    gray90: "#E3E4E6",
    gray94: "#EEEEEF",
    gray96: "#F4F5F5",
    gray98: "#FAFAFA",
    gray100: "#FDFCFC"
  },
  icons: {
    green3: "#C3F4C9",
    orange: "#FF733E",
    violet: "#A861FF",
    gray: "#DDDDDD",
    red: "#F23E3E"
  },
  backgrounds: {
    violet: "#F4EBFF",
    orange: "#FFF0EB",
    green: "#F5FFF6",
    red: "#FEECEC"
  }
};

export default colors;